<template>
    <div class="sub-system-list">
        <el-form label-width="135px" >
            <el-form-item label="服列表地址:"><el-tooltip placement="top-start"  content="由CP研发人员提供，获取服务列表信息">
                <i class="el-icon-question"></i></el-tooltip>
                <el-input class="el-input--small" v-model="serverListUrl" style="width: 70%"  @blur="checkUrl('server')" ref="serverlist">

            </el-input>
                <el-button icon="el-icon-refresh" size="mini" type="primary" @click="showTest('server')">
                    测试
                </el-button>
            </el-form-item>
            <el-form-item label="角色信息接口:"><el-tooltip placement="top-start"  content="由CP研发人员提供，获取角色信息">
                <i class="el-icon-question"></i></el-tooltip>
                <el-input class="el-input--small" v-model="roleUrl" style="width: 70%" @blur="checkUrl('role')" ref="role"></el-input>
                <el-button icon="el-icon-refresh" size="mini" type="primary" @click="showTest('role')">
                    测试
                </el-button>
            </el-form-item>
            <el-form-item label="注册人数接口:"><el-tooltip placement="top-start"  content="由CP研发人员提供，获取注册人数信息">
                <i class="el-icon-question"></i></el-tooltip>
                <el-input class="el-input--small" v-model="registerUrl" style="width: 70%" @blur="checkUrl('register')" ref="register"></el-input>
                <el-button  icon="el-icon-refresh" size="mini" type="primary" @click="showTest('reg')">
                    测试
                </el-button>
            </el-form-item>
            <el-form-item label="在线人数接口:"><el-tooltip placement="top-start"  content="由CP研发人员提供，获取在线人数信息">
                <i class="el-icon-question"></i></el-tooltip>
                <el-input class="el-input--small" v-model="onlineUrl" style="width: 70%" @blur="checkUrl('online')" ref="online">

            </el-input>
                <el-button icon="el-icon-refresh" size="mini" type="primary" @click="showTest('online')">
                测试
            </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

    export default {
        name       : 'sub-game-apiinfo',
        props: ['gameApiInfo', 'ind','regionName'],
        components : {},
        data(){
            return {
                serverListUrl: '',
                roleUrl: '',
                registerUrl: '',
                onlineUrl: '',
                baseInfo:{},
            }
        },
        computed: {
            ...mapState(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment','$route']),
            ...mapState('gameConfigCommonInfo', []),



        },

        created() {
                this.serverListUrl=this.gameApiInfo.server_list;
                this.roleUrl=this.gameApiInfo.role_info;
                this.registerUrl=this.gameApiInfo.register_num;
                this.onlineUrl=this.gameApiInfo.online_num;
        },

        watch:{
            serverListUrl() {
                this.change();
            },
            roleUrl() {
                this.change();
            },
            registerUrl() {
                this.change();
            },
            onlineUrl() {
                this.change();
            }
        },

        methods: {
            ...mapActions('gameConfigCommonInfo',['SET_API_CONFIG']),

            change(){
                this.baseInfo= {
                        key:this.ind,
                        region_name:this.regionName,
                        server_list: this.serverListUrl,
                        role_info: this.roleUrl,
                        register_num: this.registerUrl,
                        online_num: this.onlineUrl
                    };


                this.SET_API_CONFIG(this.baseInfo);
            },
            showTest(type){
                this.$emit('dialog-show',{'status':true,'type':type,'serverListUrl':this.serverListUrl,roleUrl:this.roleUrl,
                    'registerUrl':this.registerUrl,'onlineUrl':this.onlineUrl});
            },
            checkUrl(type){
                let sRegex = "^((https|http|ftp|rtsp|mms)?://)"
                    + "(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
                    + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
                    + "|" // 允许IP和DOMAIN（域名）
                    + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
                    + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
                    + "[a-z]{2,6})" // first level domain- .com or .museum
                    + "(:[0-9]{1,4})?" // 端口- :80
                    + "((/?)|" // a slash isn't required if there is no file name
                    + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";

                let matchUrl = new RegExp(sRegex,'i');
                let parentSubmit = false
                if(type == "server") {
                    if (this.serverListUrl && !matchUrl.test(this.serverListUrl)) {
                        this.$message({
                            message: '请输入有效的服列表地址！',
                            type: 'error',
                            showClose: true
                        });
                        this.$refs['serverlist'].focus();
                        parentSubmit = true;
                    }
                }else if(type == "role")
                {
                    if (this.roleUrl && !matchUrl.test(this.roleUrl)) {
                        this.$message({
                            message: '请输入有效的角色信息地址！',
                            type: 'error',
                            showClose: true
                        });
                        this.$refs['role'].focus();
                        parentSubmit = true;
                    }
                } else if (type == "register") {
                    if (this.registerUrl && !matchUrl.test(this.registerUrl)) {
                        this.$message({
                            message: '请输入有效的注册人数地址！',
                            type: 'error',
                            showClose: true
                        });
                        this.$refs['register'].focus();
                        parentSubmit = true;
                    }
                } else if (type == "online") {
                    if (this.onlineUrl && !matchUrl.test(this.onlineUrl)) {
                        this.$message({
                            message: '请输入有效的在线人数地址！',
                            type: 'error',
                            showClose: true
                        });
                        this.$refs['online'].focus();
                        parentSubmit = true;
                    }
                }
                this.$emit('child-event', parentSubmit);
            }

        }
    };
</script>

<style type="scss" scoped>
    .el-icon-question{color: #333;font-size: 15px}
    .el-input--small{
        max-width: 500px !important;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/game/apiinfo.vue